app.factory("Users", ["$http",
    function ($http) {
        var Users = {};

        Users.list = function (params) {
            params = params || {};
            params.limit = params.limit || 10;
            params.page = params.page || 1;

            return $http.get("/user/list", {
                params: {
                    page: params.page,
                    limit: params.limit,
                    query: params.query,
                    right: params.right,
                    signature: params.signature
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        Users.listWithPersonalNos = function (personalNos) {
            return $http.post('/user/list', { personalNos: personalNos }).then(function (resp) {
                return resp.data;
            })
        };

        Users.profile = function (profileId) {
            return $http.get("/user/profile/" + profileId).then(function (resp) {
                return resp.data;
            });
        };

        Users.search = function (personalNo) {
            return $http.get("/user/search", {
                params: { personalNo: personalNo }
            }).then(function (resp) {
                return resp.data;
            })
        };

        Users.create = function (params) {
            return $http.post("/user/create", {
                email: params.email,
                personalNo: params.personalNo,
                documentNo: params.documentNo,
                firstName: params.firstName,
                lastName: params.lastName,
                birthDate: params.birthDate,
                birthPlace: params.birthPlace,
                gender: params.gender,
                password: params.password,
                userConfig: {},
                image: params.image,
                phone: params.phone,
                citizenship: params.citizenship,
                nationality: params.nationality,
                physicalAddress: params.physicalAddress,
                legalAddress: params.legalAddress
            }).then(function () {
                return true;
            });
        };

        Users.update = function (params) {
            return $http.post("/user/update", {
                _id: params._id,
                email: params.email,
                personalNo: params.personalNo,
                documentNo: params.documentNo,
                firstName: params.firstName,
                lastName: params.lastName,
                birthDate: params.birthDate,
                birthPlace: params.birthPlace,
                gender: params.gender,
                password: params.password,
                userConfig: params.userConfig || {},
                image: params.image,
                phone: params.phone,
                citizenship: params.citizenship,
                nationality: params.nationality,
                physicalAddress: params.physicalAddress,
                legalAddress: params.legalAddress
            }).then(function (user) {
                return user;
            });
        };

        Users.fetchOne = function (userId) {
            return $http.get("/user/" + userId).then(function (resp) {
                return resp.data;
            });
        };

        Users.remove = function (userId) {
            return $http.post("/user/remove", {
                userId: userId
            }).then(function (resp) {
                return resp.data;
            });
        };

        return Users;
    }
]);
